
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import Navbar from "../components/navbar";
import Footer from "../components/footer";

import Home from "../pages/Home";
import LoginPage from "../pages/Login";
import RegisterPage from "../pages/Register";
import CoursesPage from "../pages/Courses";
import Community from "../pages/Community";
import StudyNotes from "../pages/StudyNotes";
import StudentSupport from "../pages/StudentSupport";

import AdminRoutes from "./AdminRoutes";
import StudentRoutes from "./StudentRoutes";
import TeacherRoutes from "./TeacherRoutes";

import AdminAuth from "../Admin/componants/AdminAuth";
import AllClasses from "../components/AllClasses";
import LiveBatches from "../components/LiveBatches";
import MediitSkills from "../components/LMSSkills";
import RealTest from "../components/RealTest";
import OurMentors from "../components/OurMentors";
import TalkToCounselor from "../components/TalkToCounselor";
import About from "../pages/About";
import CourseRedirect from "../components/CourseRedirect";
import HowLiveClassWorks from "../pages/HowLiveClassWorks";

// Course purchase ab student folder me hai
import CoursePurchase from "../student/CoursePurchase";

import {
  AskDoubt,
  Career,
  DownloadApp,
  FAQs,
  HelpCenter,
  PrivacyPolicy,
  RefundPolicy,
  TermsAndConditions,
} from "../pages/FooterStaticPages";
import AiChatbot from "../components/AiChatbot";

const UserLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
      <AiChatbot />
    </div>
  );
};

const AppRouts: React.FC = () => {
  return (
    <Router>
      <Routes>
        {/* Admin / Teacher / Student Dashboard Routes - No Website Navbar Footer */}
        <Route path="/LMS/login" element={<AdminAuth />} />
        <Route path="/learn-with-us/*" element={<AdminRoutes />} />
        <Route path="/teach-with-us/*" element={<TeacherRoutes />} />
        <Route path="/student-dashboard/*" element={<StudentRoutes />} />
        

        {/* Auth Routes - No Navbar Footer */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />

        {/* Old Profile URL Safety Redirect */}
        <Route
          path="/profile"
          element={<Navigate to="/student-dashboard/profile" replace />}
        />

        {/* Optional old student URL safety redirects */}
        <Route
          path="/student"
          element={<Navigate to="/student-dashboard" replace />}
        />

        <Route
          path="/student/profile"
          element={<Navigate to="/student-dashboard/profile" replace />}
        />

        <Route
          path="/student/live-classes"
          element={<Navigate to="/student-dashboard/live-classes" replace />}
        />

        {/* <Route
          path="/student/my-courses"
          element={<Navigate to="/student-dashboard/my-courses" replace />}
        /> */}

        {/* Course Purchase */}
        <Route path="/course-purchase/:courseId" element={<CoursePurchase />} />

        {/* Website Routes - With Navbar Footer */}
        <Route
          path="/"
          element={
            <UserLayout>
              <Home />
            </UserLayout>
          }
        />

        <Route
          path="/live-batches"
          element={
            <UserLayout>
              <LiveBatches />
            </UserLayout>
          }
        />

        <Route
          path="/lms-skills"
          element={
            <UserLayout>
              <MediitSkills />
            </UserLayout>
          }
        />

        <Route
          path="/real-test"
          element={
            <UserLayout>
              <RealTest />
            </UserLayout>
          }
        />

        <Route
          path="/our-mentors"
          element={
            <UserLayout>
              <OurMentors />
            </UserLayout>
          }
        />

        <Route
          path="/contact"
          element={
            <UserLayout>
              <TalkToCounselor />
            </UserLayout>
          }
        />

        <Route
          path="/talk-to-counselor"
          element={
            <UserLayout>
              <TalkToCounselor />
            </UserLayout>
          }
        />

        <Route
          path="/courses"
          element={
            <UserLayout>
              <CoursesPage />
            </UserLayout>
          }
        />

        <Route
          path="/community"
          element={
            <UserLayout>
              <Community />
            </UserLayout>
          }
        />

        <Route
          path="/study-notes"
          element={
            <UserLayout>
              <StudyNotes />
            </UserLayout>
          }
        />

        <Route
          path="/student-support"
          element={
            <UserLayout>
              <StudentSupport />
            </UserLayout>
          }
        />

        <Route
          path="/all-classes"
          element={
            <UserLayout>
              <AllClasses />
            </UserLayout>
          }
        />

        <Route
          path="/about"
          element={
            <UserLayout>
              <About />
            </UserLayout>
          }
        />

        <Route
          path="/how-live-class-works"
          element={
            <UserLayout>
              <HowLiveClassWorks />
            </UserLayout>
          }
        />

        {/* Footer Support Pages */}
        <Route
          path="/help-center"
          element={
            <UserLayout>
              <HelpCenter />
            </UserLayout>
          }
        />

        <Route
          path="/ask-doubt"
          element={
            <UserLayout>
              <AskDoubt />
            </UserLayout>
          }
        />

        <Route
          path="/refund-policy"
          element={
            <UserLayout>
              <RefundPolicy />
            </UserLayout>
          }
        />

        <Route
          path="/privacy-policy"
          element={
            <UserLayout>
              <PrivacyPolicy />
            </UserLayout>
          }
        />

        <Route
          path="/terms-and-conditions"
          element={
            <UserLayout>
              <TermsAndConditions />
            </UserLayout>
          }
        />

        <Route
          path="/faqs"
          element={
            <UserLayout>
              <FAQs />
            </UserLayout>
          }
        />

        <Route
          path="/career"
          element={
            <UserLayout>
              <Career />
            </UserLayout>
          }
        />

        <Route
          path="/download-app"
          element={
            <UserLayout>
              <DownloadApp />
            </UserLayout>
          }
        />

        {/* Old course links safety redirects */}
        <Route path="/courses/:slug" element={<CourseRedirect />} />
        <Route
          path="/courses/:classId/:courseSlug"
          element={<CourseRedirect />}
        />

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
};

export default AppRouts;